export function Signal({ className = '' }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 160 160" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id="wf-signal" x1="18" y1="36" x2="136" y2="126" gradientUnits="userSpaceOnUse">
          <stop stopColor="#32c5e8" />
          <stop offset=".56" stopColor="#6d72e8" />
          <stop offset="1" stopColor="#a06bee" />
        </linearGradient>
        <linearGradient id="wf-beam" x1="0" y1="80" x2="160" y2="80" gradientUnits="userSpaceOnUse">
          <stop stopColor="#32c5e8" stopOpacity="0" />
          <stop offset=".32" stopColor="#32c5e8" />
          <stop offset=".68" stopColor="#8e6deb" />
          <stop offset="1" stopColor="#8e6deb" stopOpacity="0" />
        </linearGradient>
      </defs>
      <line x1="0" y1="80" x2="160" y2="80" stroke="url(#wf-beam)" strokeWidth="1.5" />
      <path
        d="M80 7C84 48 96 72 153 80C96 88 84 112 80 153C76 112 64 88 7 80C64 72 76 48 80 7Z"
        fill="url(#wf-signal)"
      />
      <circle cx="91" cy="91" r="4" fill="#f6bb45" />
    </svg>
  );
}

export function BrandLockup({ inverse = false }: { inverse?: boolean }) {
  return (
    <span className={`brand-lockup${inverse ? ' brand-lockup--inverse' : ''}`} aria-label="Wellness Frontier">
      <Signal className="brand-lockup__signal" />
      <span className="brand-lockup__words" aria-hidden="true">
        <span>Wellness</span>
        <span>Frontier</span>
      </span>
    </span>
  );
}
